import { getApolloClient } from '../../../contextProviders/ApolloClientContext';
import { GET_ROUTE_PLAN_DETAIL, SuccessResponse, Variables } from './query';

export default async function fetchRouteDetails(id: string) {
  const client = getApolloClient();
  return await client?.query<SuccessResponse, Variables>({query: GET_ROUTE_PLAN_DETAIL, variables: {id}});
}
